<template>
    <div :class="classNamesElement">
        <label :for="id" v-if="label">
            <translate>{{ label }}</translate>
        </label>
        <input class="form-input" :type="inputType" :name="id" :id="id" v-model="proxyValue" ref="input" :placeholder="placeholder"
               :required="required" :autofocus="autofocus" :autocomplete="autocomplete" :disabled="disabled"
               @blur="hasFocus = false" @focus="hasFocus = true">
        <svg-vue v-if="icon" :icon="icon" class="icon"/>
        <svg-vue v-if="clearable" icon="delete-disabled-cross" class="icon icon--clear" @click="clear"/>
        <svg-vue v-if="closeable" icon="cross-head-circle" class="icon icon--clear" @click="close"/>
        <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
    </div>
</template>

<script>
export default {
    name: 'FormInput',
    props: {
        modelValue: null,
        id: null,
        type: null,
        label: null,
        placeholder: null,
        required: null,
        autofocus: null,
        autocomplete: null,
        error: null,
        info: null,
        disabled: null,
        icon: null,
        currency: null,
        suffix: null,
        decimal: null,
        closeable: null,
    },
    computed: {
        proxyValue: {
            get() {
                if (this.currency) {
                    if (this.hasFocus) {
                        return this.modelValue ? this.modelValue.toString().replace('.', ',') : null;
                    } else {
                        return this.modelValue ? this.$currency(this.modelValue.toString().replace(',', '.')) : null;
                    }
                } else if (this.decimal) {
                    const suffix = this.suffix ? this.suffix : '';
                    if (this.hasFocus) {
                        return this.modelValue.toString().replace('.', ',').replace(' ' + suffix, '');
                    } else {
                        return this.modelValue ? this.modelValue.toString().replace('.', ',') + ' ' + suffix : null;
                    }
                } else {
                    const suffix = this.suffix ? this.suffix : null;
                    if (this.hasFocus) {
                        return this.modelValue ? suffix ? this.modelValue.toString().replace(' ' + suffix, '') : this.modelValue  : null;
                    } else {
                        return this.modelValue ? suffix ? this.modelValue.toString()+ ' ' + suffix : this.modelValue  : null;
                    }
                }

            },
            set(val) {
                if (this.currency) {
                    this.$emit('update:modelValue', val.replace(/[^\d,]+/g, '').replace(',', '.'));
                } else if (this.decimal){
                    const suffix = this.suffix ? this.suffix : '';
                    this.$emit('update:modelValue', val.replace('.', ',').replace(' ' + suffix, ''));
                } else {
                    const suffix = this.suffix ? this.suffix : null;
                    if (suffix) {
                        this.$emit('update:modelValue', val.replace(' ' + suffix, ''));
                    } else {
                        this.$emit('update:modelValue', val);
                    }

                }
            }
        },
        inputType() {
            return this.type ? this.type : 'text';
        },
        classNamesElement() {
            let classNames = ['form-element'];
            if (this.error) classNames.push('form-element--error');
            if (!this.error && this.modelValue) classNames.push('form-element--valid');
            // if (this.icon) classNames.push('form-element--icon');
            classNames.push('form-element--icon');

            if (this.modelValue) classNames.push('form-element--filled');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : this.info;
        },
        clearable() {
            return !this.disabled && !this.icon && this.modelValue && this.type !== 'hidden';
        }
    },
    data() {
        return {hasFocus: false};
    },
    emits: ['update:modelValue', 'cleared', 'closed'],
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        clear() {
            this.$refs.input.value = '';
            this.$emit('update:modelValue', '');
            this.$emit('cleared');
        },
        close() {
            this.$emit('closed');
        }
    }
};
</script>
